<div fxLayout="row" fxLayoutAlign="space-between center"
     fxLayout.lt-lg="column" fxLayoutAlign.lt-lg="space-evenly center"
     class="footer">
    <img src="assets/logo_footer.png" class="footer-logo start" [alt]="'logo'|i18n">
    <div class="footer-text" [ngClass]="{'end': !address }">{{ copyright }}</div>
    <div *ngIf="address" class="new-line" [ngClass]="{'end': address }">{{ address }}</div>
</div>
